export class DeclineAssigment {
    solicitud: number;
    consecutivo: number;
    justificacion: String;
    usuario: String;
}
